"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "sendUserConsents", {
    enumerable: true,
    get: function() {
        return sendUserConsents;
    }
});
var _apiCallFunctions = require("../../helpers/apiCallFunctions");
var _utils = require("./utils");
var JOBTEASER_HOSTS = [
    ".dev.jobteaser.net",
    ".jobteaser.com"
];
var sendUserConsents = function(logger) {
    var apiHost = JOBTEASER_HOSTS.find(function(host) {
        return window.location.hostname.endsWith(host);
    }) || "";
    if (typeof window === "undefined" || !apiHost) {
        return;
    }
    var userConsents = (0, _utils.getUserPurposesConsents)({
        filterBy: "short_name"
    });
    if (logger) {
        logger.info("\uD83D\uDCC8 Rudderstack - sendUserConsents to api", {
            userConsents: userConsents
        });
    }
    var urlEndpoint = "https://api".concat(apiHost, "/v1/rudderstack/consents");
    var payload = {
        consents: userConsents
    };
    (0, _apiCallFunctions.xhrCall)({
        method: "PUT",
        url: urlEndpoint,
        payload: payload,
        withCredentials: true
    }, function(error) {
        if (error) {
            console.error("sendUserConsents #1", error);
        }
    });
};

//# sourceMappingURL=sendUserConsents.js.map